<template lang="pug">
div.container
  section.row
    .page-header
      router-link.back(:to="{ path: '/', params: {} }") &larr; Back
      h1 Backgrounds
      h5 1920x1080
      ul.itemList
        li(v-for="(i) in itemCount")
          a(:href="`/static/backgrounds/1920x1080/${i}.png`" :name="i") Background {{ i }}
      h5 1680x1050
      ul.itemList
        li(v-for="(i) in itemCount")
          a(:href="`/static/backgrounds/1680x1050/${i}.png`" :name="i") Background {{ i }}
      h5 750x1334 (mobile)
      ul.itemList
        li(v-for="(i) in itemCount")
          a(:href="`/static/backgrounds/mobile/750x1334/${i}.png`" :name="i") Background {{ i }}
      h5 828x1792 (mobile)
      ul.itemList
        li(v-for="(i) in itemCount")
          a(:href="`/static/backgrounds/mobile/828x1792/${i}.png`" :name="i") Background {{ i }}
</template>

<script>

export default {
  name: 'backgroundList',
  components: {},
  data: function () {
    return {
      itemCount: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}

</script>

<style lang="scss">
  .itemList{
    list-style: none;
    a{ color: $white; text-decoration: underline;}
  }
  h5{
    font-weight: 700;
  }
  .back{
    color: $white;
    background: get-color(secondary);
    padding: (measure(xxs) / 2) measure(xxs);
    margin-bottom: measure(xxs);
    font-family: $header-font-family;
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/scenes/pages/backgroundList.vue